<template>
   <v-card flat>
    <v-card-title>Error Messages</v-card-title>
    <hr />
    <v-card-text>If an error occurs while executing your call, our API will return an Error Message. In that case it results also the Response code and the error message. Here is how an Error Reply looks like:</v-card-text>
    <v-card-text>
      <pre><code>
        {
        Error in reading from database
        }
      </code></pre>
    </v-card-text>

    <v-card-text>Here is the complete list of Error Codes and Error Messages:</v-card-text>

    <v-card-text>
      <v-simple-table class="table">
        <template v-slot:default>
          <thead>
            <tr>
              <td>Response Code</td>
              <td>Error Message</td>
              <td>Description</td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>500</td>
              <td>Error in reading from database.</td>
              <td>If any error occurred while reading data from database.</td>
            </tr>
            <tr>
              <td>404</td>
              <td>Postcode does not exist.</td>
              <td>When Postcode is invalid used in request.</td>
            </tr>
            <tr>
              <td>400</td>
              <td>Only a single wildcard character can be entered in a postcode.</td>
              <td>When in Postcode 2 or more than 2 wildcard character used in request.</td>
            </tr>
            <tr>
              <td>400</td>
              <td>"Message": "The request is invalid".</td>
              <td>If addressId is invalid.</td>
            </tr>
            <tr>
              <td>400</td>
              <td>Locality and Thoroughfare must have a minimum length of three characters.</td>
              <td>If Locality and Thoroughfare value is less than 3 characters.</td>
            </tr>
            <tr>
              <td>401</td>
              <td>"Message": "Authorization has been denied for this request".</td>
              <td>While sending request If you have not used authorization token value as Authorization.</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>

    <v-card-text>In the unlikely event of repeatedly receiving 500 error response codes please contact the GeoAd team for support.</v-card-text>
    <br />
  </v-card>
</template>

<script>
export default {
  name: "MainPage",
  data: () => ({
    orderNumber: 11
  })
};
</script>